/* src/app/core/directives/popover/custom-tooltip/custom-tooltip.component.scss */
.tooltip-conatiner {
  padding: 20px;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
  transition: all 0.15s ease;
}
/*# sourceMappingURL=custom-tooltip.component.css.map */
